import { Accordion, AccordionItem, AccordionButton } from '@faststore/ui'
import React, { useEffect, useState } from 'react'

import { AccordionContent } from './components/AccordionContent/AccordionContent'
import { MenuIcon } from '../../../../assets/MenuIcon'

interface DesktopMenuAccordionProps {
  couponsLoading: boolean
  hasActiveCoupons: boolean
  menuOpen?: boolean
  allCategories?: any
  setMenuOpen: (menuOpen: boolean) => void
}

export const DesktopMenuAccordion = ({
  couponsLoading,
  hasActiveCoupons,
  menuOpen,
  allCategories,
  setMenuOpen,
}: DesktopMenuAccordionProps) => {
  const [indicesExpanded, setIndicesExpanded] = useState<Set<number>>(
    new Set([])
  )

  const [position, setPosition] = useState<number | undefined>()
  const [allCategoriesVisibility, setAllCategoriesVisibility] = useState(false)
  const [currentCategorie, setCurrentCategorie] = useState('')
  const [subCategoriePosition, setSubCategoriePosition] = useState<number>(0)

  const onChange = (index: number) => {
    if (indicesExpanded.has(index)) {
      indicesExpanded.delete(index)
      setIndicesExpanded(new Set(indicesExpanded))
    } else {
      setIndicesExpanded(new Set(indicesExpanded.add(index)))
    }
  }

  const closeAllMenu = () => {
    setMenuOpen(false)
    setAllCategoriesVisibility(false)
  }

  useEffect(() => {
    if (currentCategorie !== '') {
      return
    }

    if (position && position > 0) {
      setAllCategoriesVisibility(true)

      return
    }

    setPosition(undefined)
  }, [currentCategorie, menuOpen, position])

  return (
    <Accordion
      onChange={onChange}
      onMouseEnter={() => {
        setMenuOpen(true)
      }}
      onMouseLeave={() => closeAllMenu()}
      indices={indicesExpanded}
    >
      <AccordionItem>
        <AccordionButton className="accordion-button">
          <div>
            <MenuIcon color="var(--color-grayScale-white)" />
            Todas as categorias
          </div>
        </AccordionButton>

        {menuOpen && (
          <AccordionContent
            couponsLoading={couponsLoading}
            hasActiveCoupons={hasActiveCoupons}
            subCategoriePosition={subCategoriePosition}
            setSubCategoriePosition={setSubCategoriePosition}
            setCurrentCategorie={setCurrentCategorie}
            currentCategorie={currentCategorie}
            closeMenu={closeAllMenu}
            allCategoriesVisibility={allCategoriesVisibility}
            setAllCategoriesVisibility={setAllCategoriesVisibility}
            departament={allCategories}
            position={position}
            setPosition={setPosition}
          />
        )}
      </AccordionItem>
    </Accordion>
  )
}
